import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MenuItem } from 'primeng/api';

@Injectable()
export class AppBreadcrumbService {

    private itemsSource = new Subject<MenuItem[]>();
    private centerLabelSource = new Subject<string>();

    itemsHandler = this.itemsSource.asObservable();
    centerLabelHandler = this.centerLabelSource.asObservable();

    setItems(items: MenuItem[]) {
        this.itemsSource.next(items);
    }

    setCenterLabel(label: string) {
        this.centerLabelSource.next(label || "");
    }
}
